import http_helper from "../../base/http_helper"

export default{
    container: "#modal_chart",
    generateChart(station_prefix_id){
        this.showLoadings()
        let params = {
            station_prefix_ids: [station_prefix_id],
            time :72,
            time_type: 'hour'
        }
        http_helper.get("/sibh/api/v1/measurements/time_ago",params).then(data=>{
            let measurements = data.json
            $(this.container).find('.modal-body').html("<div id='chart_container'></div>")
            $(this.container).find('.header-title').html('<h5 class="modal-title">'+measurements[0].prefix+' - '+measurements[0].station_name+'</h5>')
            this.chart(measurements,'chart_container')
        })
    },
    showLoadings(){
        $(this.container).find('.header-title').html(this.generateEsqueleton('line'))
        $(this.container).find('.modal-body').html(this.generateEsqueleton('body-lg'))
    },
    generateEsqueleton(klass){
        return '<div class="skeleton-screen-container"><div class="skeleton-'+klass+'"></div></div>'
    },
    chart(measurements, chart_container){
        let chart = new Highcharts.Chart({
            chart: {
              renderTo: chart_container,
              type: 'column',
              zoomType: "x",
            },
            title: {
                text: 'Chuva últimas 72hs'
            },
            subtitle: {
                text: 'Departamente de Águas e Energia Elétrica'
            },
            xAxis: {
                type: 'datetime',
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Chuva (mm)'
                },
                labels: {
                  format: '{value}'
                }
            },
            tooltip: {
                formatter: function () {
                    let text = '<b>' + moment(this.x).format('DD/MM HH:mm') + '</b>';
                    text += '<br/><b><span style="color:'+ this.point.color +'">' + this.y +'</span></b> mm'
                    return text;
                },
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
                series: {
                  cursor: 'pointer',
                }
            
            },
            series: this.generateSeries(measurements),
            credits: {
                enabled: false
            }
              
        })      
    },
    generateSeries(measurements){
        let series = [];
        series.push(
            {
                name: measurements[0].prefix,
                data: measurements.map(x=>[moment(x.date_hour, "YYYY-MM-DDTHH:mm:ss.SSSZ").valueOf(), parseFloat(x.value.toFixed(1))])
            }
        );
        return series
    },
    toLocal(timestamp){
        return timestamp
    }
}